// extracted by mini-css-extract-plugin
export var dividerContainer = "_9t-0";
export var line = "_9t-1";